import { classes } from 'html-classes';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';

import styles from './styles.module.scss';

interface PolicyAgreementProps {
  policyAgreement: boolean;
  policyError: boolean;
  onChange: (checked: boolean) => void;
}

const termsUrls = [
  company.config.links.legals?.generalTradingPolicy || { link: '' },
  company.config.links.legals?.privacyPolicy || { link: '' },
];

export default function PolicyAgreement({
  policyAgreement,
  policyError,
  onChange,
}: PolicyAgreementProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.agreement}>
      <label className="type control__checkbox">
        <input
          data-checkbox="auth-agree"
          type="checkbox"
          checked={policyAgreement}
          className="type control__checkbox-input"
          onChange={() => onChange(!policyAgreement)}
        />
        <span className="type control__checkbox-mark" />
        <span>
          <Trans
            i18nKey="phrases:agreeToCollectionShort"
            components={termsUrls.map(({ link = '' }) => (
              <Link to={link} key={link} />
            ))}
          />
        </span>
      </label>
      {policyError && (
        <div className={classes(['error-label', styles.error])}>
          {t('phrases:policyError')}
        </div>
      )}
    </div>
  );
}
